import { Button, Grid, Typography } from '@material-ui/core';
import React from 'react';
import ProgressIndicator from './ProgressIndicator';
import { Alert, AlertTitle } from '@material-ui/lab';
import { OperationLog} from './Paperbase';
import ClearIcon from '@material-ui/icons/Clear';
import { ResultFileState } from './ConfigFormData';
import { Operations } from './NavigatorData';
import { DeltaXMLColors, DeltaJSONColors } from '../styling/DeltaColors';

export interface OperationLogsProps {
    operation: Operations;
    logs : OperationLog[];
    percentage: number;
    resultFileState: ResultFileState;
    onClearLog :() => void;
}

export function OperationLogs(props : OperationLogsProps){
    let { operation, logs, percentage, resultFileState, onClearLog} = props;

    return (logs.length > 0)?
            <Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item style={{float: 'left'}}>
                        <Typography variant="h5" color="primary" style ={{padding: '10px 10px'}}>
                            {operation}
                        </Typography>
                    </Grid>
                    <Button variant="contained"
                            color="primary"
                            onClick={onClearLog}
                            endIcon={<ClearIcon />}>
                        Clear
                    </Button>
                    <ProgressIndicator percentage={percentage}  operation={operation} resultFileState={resultFileState}/>
                </Grid>
                <Grid style={{backgroundColor: DeltaJSONColors.WHITE, padding: '5px 5px', margin: '5px 5px'}}>   
                    {logs.map((log) => (
                    (log.message !== "")?
                        <Alert severity={log.type} style={{padding: '5px 5px', margin: '5px 5px'}} >
                            <AlertTitle style={{fontSize: '14px',fontWeight: 600,lineHeight: '20px', color:DeltaXMLColors.OXFORD_BLUE}}>{log.title}</AlertTitle>
                            <Typography variant="body2" color="primary">
                                [{log.time}] {(log.message !== undefined) ? log.message.replace("{"," ").replace("}", " ").replace("progressInPercentage", "Progress").replace("pipelineStage", "Stage").replace("jobStatus","Status") : log.message}
                            </Typography>
                        </Alert>
                    :<Grid/>
                    ))}
                </Grid>
            </Grid>
            :<div/>
}

export default (OperationLogs);